export function inspectMatrix() {
  var indent = ' '.repeat(2);
  var indentData = ' '.repeat(4);
  return "".concat(this.constructor.name, " {\n").concat(indent, "[\n").concat(indentData).concat(inspectData(this, indentData), "\n").concat(indent, "]\n").concat(indent, "rows: ").concat(this.rows, "\n").concat(indent, "columns: ").concat(this.columns, "\n}");
}
var maxRows = 15;
var maxColumns = 10;
var maxNumSize = 8;

function inspectData(matrix, indent) {
  var rows = matrix.rows,
      columns = matrix.columns;
  var maxI = Math.min(rows, maxRows);
  var maxJ = Math.min(columns, maxColumns);
  var result = [];

  for (var i = 0; i < maxI; i++) {
    var line = [];

    for (var j = 0; j < maxJ; j++) {
      line.push(formatNumber(matrix.get(i, j)));
    }

    result.push("".concat(line.join(' ')));
  }

  if (maxJ !== columns) {
    result[result.length - 1] += " ... ".concat(columns - maxColumns, " more columns");
  }

  if (maxI !== rows) {
    result.push("... ".concat(rows - maxRows, " more rows"));
  }

  return result.join("\n".concat(indent));
}

function formatNumber(num) {
  var numStr = String(num);

  if (numStr.length <= maxNumSize) {
    return numStr.padEnd(maxNumSize, ' ');
  }

  var precise = num.toPrecision(maxNumSize - 2);

  if (precise.length <= maxNumSize) {
    return precise;
  }

  var exponential = num.toExponential(maxNumSize - 2);
  var eIndex = exponential.indexOf('e');
  var e = exponential.substring(eIndex);
  return exponential.substring(0, maxNumSize - e.length) + e;
}